import { trackEvent } from '../analytics'
import { BOOKING_URL, BOOK_INTRO, CLOSE, EMAIL } from '../data/content'

export default function Close() {
  return (
    <section className="sheet close">
      <div className="container">
        <h2>{CLOSE.heading}</h2>
        <p>{CLOSE.body}</p>
        <div className="btn-row section-cta">
          <a
            className="btn btn-primary"
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('booking_click', { location: 'close' })}
          >
            {BOOK_INTRO}
          </a>
          <a className="btn btn-ghost" href={`mailto:${EMAIL}`} onClick={() => trackEvent('email_click', { location: 'close' })}>
            {EMAIL}
          </a>
        </div>
      </div>
    </section>
  )
}
